enum Types {
  PENDING_CONNECTIONS_REQUEST = 'PENDING_CONNECTIONS_REQUEST',
  PENDING_CONNECTIONS_FULFILLED = 'PENDING_CONNECTIONS_FULFILLED',
  PENDING_CONNECTIONS_REJECTED = 'PENDING_CONNECTIONS_REJECTED',

  PENDING_SET_TIMER = 'PENDING_SET_TIMER',
}

export default Types;
